module.exports = __webpack_public_path__ + "media/images/flags/nr-81dae9d589109e3f1a0e5a3a214a2a1c.svg";